import React, {useEffect, useRef, useState} from "react";
import "./Festivaldetail.scss";
import 'swiper/swiper-bundle.min.css';
import Swiper from "swiper";

import {useHistory, useLocation} from "react-router-dom";
import {FestivalDetailData} from "./FestivalDetailServices";
import {TextBreak} from "../../Components";
import {ConvertTMonthName} from "../../Services";
import moment from "moment-jalaali";
import {LotteryCard} from "./LotteryCard";
import {useResp} from "../../hooks";
import CampaignDetailDesktop from "../CampaignDetailDesktop/CampaignDetailDesktop";


function FestivalDetail() {

    //hooks
    const history = useHistory();
    const swiper = useRef(null);
    const location = useLocation();

    //states
    const [festival,setFestival] = useState(null);
    const [coordinates,setCoordinates] = useState(null);




    // DualSliderDesktop ----------------------------------------------
    const Loop = ()=>{
        setInterval(()=>{
            swiper.current.slideNext();
        },2000)
    }

    useEffect(()=>{
        window.scrollTo({left: 0, top: 0});
        if(location.state && location.state.festival){
            getFestivalDetail();
            setFestival(location.state.festival);
        }
        swiper.current=new Swiper('.swiper-containera',{
            loop:true,
            autoplay: {
                delay: 5000,
            },
        })
        //Loop();
    },[])


    //Map route ---------------------------------------------------------------
    useEffect(()=>{
        if(location.state && location.state.festival.geometry){
            setCoordinates({
                lng:location.state.festival.geometry.coordinates[0],
                lat:location.state.festival.geometry.coordinates[1]
            })
        }
    },[location.state])

    const ConvertToJalaliSplited = (date) =>{
        if(date){
            let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
            let year = moment.utc(date.split('+')[0]).format('jYYYY');
            let day = moment.utc(date.split('+')[0]).format('jDD');
            return day+" "+month+""+year
        }
        return ""
    }

    const mapsSelector = () =>{
        if(coordinates){
            if /* if we're on iOS, open in Apple Maps */
            ((navigator.platform.indexOf("iPhone") != -1) ||
                (navigator.platform.indexOf("iPad") != -1) ||
                (navigator.platform.indexOf("iPod") != -1))
                window.open("maps://maps.google.com/maps?daddr="+coordinates.lat+","+coordinates.lng+"&amp;ll=");
            else /* else use Google */
                window.open("https://maps.google.com/maps?daddr="+coordinates.lat+","+coordinates.lng+"&amp;ll=");
        }
    }


    //fetch festivals ------------------------------------------------------
    const getFestivalDetail = async () => {
        try{
            let response = await FestivalDetailData(location.state.festival.uid);
            setFestival(response.data);
            // console.log("Console : ",response.data)
            if(response.data.merchant && response.data.merchant.geometry){
                // console.log("Console : ",response.data)
                setCoordinates({
                    lng:response.data.merchant.geometry.coordinates[0],
                    lat:response.data.merchant.geometry.coordinates[1]
                })
            }
        }catch (e) {
            // console.log(e)
        }
    }



    const resp = useResp();


    return(
        <>
            {resp?
                <CampaignDetailDesktop/>
                :<div className="page" >
                <div className="storeDetail-container">
                    {/*Header*/}
                    <div className="customer-header">
                        <span>{festival && festival.title}</span>
                        <i className="fa fa-arrow-right back_btn" onClick={()=>history.goBack()}></i>
                    </div>

                    {/*DualSliderDesktop*/}
                    <div className="storeDetail-slider">
                        {festival?<div className="swiper-containera swiper1">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide"><img src={festival.cover ||festival.image}/></div>
                            </div>
                        </div>:null}
                    </div>

                    {/*Info*/}
                    <div className="storeDetail-info">
                        <div className="storeDetail-info-name">
                            <span className="storeDetail-info-name-title">{festival && festival.merchant && festival.merchant.name}</span>
                            <span className="storeDetail-info-name-point" style={{direction:"rtl"}}>{festival && ConvertToJalaliSplited(festival.start_date)}</span>
                        </div>
                        <div className="storeDetail-info-logo">
                            {festival && festival.merchant?<img src={ festival.merchant.thumbnail } alt=""/>:null}
                        </div>
                    </div>



                    {/*About*/}
                    <div className="festivalDetail-about">

                        <div className="storeDetail-about-titre">
                            <span>توضیحات تکمیلی</span>
                        </div>

                        <div className="storeDetail-about-body">
                            {/*<p>{festival  && festival.description}</p>*/}
                            {festival && festival.description?<TextBreak text={festival.description}/>:null}
                            {/*<p>{festival && festival.merchant && festival.merchant.description}</p>*/}
                            <br/>
                        </div>

                    </div>

                    {/*Actions*/}

                    {/*<div className="storeDetail-actions">*/}
                    {/*    <div className="storeDetail-actions-item-back" onClick={()=>{*/}
                    {/*        if(festival.merchant.phone){*/}
                    {/*            document.location.href="tel:"+festival.merchant.phone;*/}
                    {/*        }else {*/}
                    {/*            //document.location.href="tel:"+'';*/}
                    {/*        }*/}
                    {/*    }}>*/}
                    {/*        <img src="/svg/phone.svg" alt=""/>*/}
                    {/*        <span>تماس</span>*/}
                    {/*    </div>*/}
                    {/*    /!*<div className="storeDetail-actions-item-back" onClick={()=>mapsSelector()}>*!/*/}
                    {/*    /!*    <img src="/svg/direction.svg" alt=""/>*!/*/}
                    {/*    /!*    <span>مسیر یابی</span>*!/*/}
                    {/*    /!*</div>*!/*/}
                    {/*    <div className="storeDetail-actions-item-back" onClick={*/}
                    {/*        ()=>{*/}
                    {/*            history.push(`/referral-camp/${festival.uid}`,{item:festival})*/}
                    {/*        }*/}
                    {/*    }>*/}
                    {/*        <img src="/svg/direction.svg" alt=""/>*/}
                    {/*        <span>دعوت از دوستان </span>*/}
                    {/*    </div>*/}
                    {/*    <div className="storeDetail-actions-item-back" onClick={*/}
                    {/*        ()=>{*/}
                    {/*            history.push(`/chat/${festival.merchant.topic}`,{merchant:festival.merchant})*/}
                    {/*        }*/}
                    {/*    }>*/}
                    {/*        <img src="/svg/chat.png" alt=""/>*/}
                    {/*        <span>چت</span>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <br/>




                    <div className="lottery-section">
                        {festival &&  festival.lotteries && festival.lotteries.length>0?
                            <div className="storeDetail-about-titre">
                                <span>قرعه کشی</span>
                            </div>:null
                        }

                        {festival && festival.lotteries && festival.lotteries.map(lot=>{
                            return(
                                <LotteryCard lot={lot}/>
                            )
                        })}
                    </div>


                </div>

            </div>}
            </>
    )
}

export {FestivalDetail};
